import React, { useEffect, useRef } from 'react'
import { format, parseISO } from 'date-fns'
import { string, object, node } from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'
import styles from './MagazineCover.module.scss'
import ResponsiveImage from '../ResponsiveImage'
import ResponsiveMedia from '../ResponsiveMedia'
import TextAlign from '../TextAlign'
import Type from '../Type'
import Hide from '../Hide'
import SmartLink from '../SmartLink'
import VanillaTilt from 'vanilla-tilt'

const Tilt = (props) => {
  const { options, children, ...rest } = props
  const tilt = useRef(null)

  useEffect(() => {
    VanillaTilt.init(tilt.current, options)
  }, [options])

  return (
    <div ref={tilt} {...rest}>
      {children}
    </div>
  )
}

Tilt.propTypes = {
  options: object,
  children: node
}

const MagazineCover = ({ issueDate, images, slug }) => (
  <SmartLink className={styles.Wrapper} to="/magazine" as={`/magazine/${slug}`}>
    <Tilt>
      <div className={styles.MagazineCover}>
        <div className={styles.Image}>
          <ResponsiveMedia ratio={446 / 321}>
            <ResponsiveImage
              alt=""
              src={images.cover_321x446_321[0].url}
              srcSet={[
                {
                  src: changeFileExtension(
                    images.cover_321x446_321[0].url,
                    'webp'
                  ),
                  width: 321
                },
                {
                  src: changeFileExtension(
                    images.cover_321x446_642[0].url,
                    'webp'
                  ),
                  width: 642
                }
              ]}
              sizes={[
                // 136 = padding between cards (3 * 24px) + content gutter (64px)
                '(min-width: 960px) calc(25vw - 136px)',
                'calc((100vw - 32px) * 0.75)'
              ]}
            />
          </ResponsiveMedia>
        </div>
      </div>
    </Tilt>
    <Hide below="desktop">
      <TextAlign center>
        <Type className={styles.Text} uppercase size="heading6" weight="bold">
          {format(parseISO(issueDate), 'MMMM')}{' '}
          <span className={styles.muted}>
            {format(parseISO(issueDate), 'yyyy')}
          </span>
        </Type>
      </TextAlign>
    </Hide>
  </SmartLink>
)

MagazineCover.propTypes = {
  issueDate: string,
  slug: string,
  images: object
}

export default MagazineCover
